export default __webpack_public_path__ + "21ddb9624177be1075597db13351f6cd.mp4";